
import angular from 'angular';

import { ApuracoesPontoModule } from './ApuracoesPonto/apuracoesponto.module';
import { GeracaoDeMarcacoesPadraoModule } from './GeracaoDeMarcacoesPadrao/geracao-de-marcacoes-padrao.module';

import { FolhasdePontoListRouting } from './FolhasDePonto/folhasdeponto.routes';
import { AnalisesPontoListRouting } from './AnalisesPonto/analisesponto.routes';
import { PagamentosPontoListRouting } from './Pagamentos/pagamentos.routes';
import { BancodeHorasListRouting } from './BancoDeHoras/bancodehoras.routes';
import { ExportacaoArquivoAejListRouting } from './ExportacaoArquivoAEJ/exportacaoarquivoaej.routes';
import { EstabelecimentosHabilitadosRouting } from './EstabelecimentosHabilitados/estabelecimentoshabilitados.routes';
import { AjustesPontoListRouting } from './AjustesPonto/ajustesponto.routes';

import { FolhasdePontoService } from './FolhasDePonto/folhasdeponto.service';
import { FolhasPontoVisualizarpdfModalService } from './FolhasDePonto/modals/visualizarpdf/visualizarpdf.modal.service';
import { FolhasPontoFalhaGeracaoModalService } from './FolhasDePonto/modals/falhageracao/falhageracao.modal.service';
import { FolhasPontoCancelarAssinaturaModalService } from './FolhasDePonto/modals/cancelarassinatura/cancelarassinatura.modal.service';
import { AnalisesPontoService } from './AnalisesPonto/analisesponto.service';
import { PagamentosPontoService } from './Pagamentos/pagamentos.service';
import { PagamentosPontoConfirmModalService } from './Pagamentos/modals/pagamentos-confirm/pagamentos-confirm.modal.service';
import { GruposPontoService } from './gruposponto.service';
import { TrabalhadoresPontoService } from './trabalhadoresponto.service';
import { TrabalhadoresApuracaoPontoService } from './trabalhadores-apuracao-ponto.service';
import { BancodeHorasService } from './BancoDeHoras/bancodehoras.service';
import { ExportacaoArquivoAejService } from './ExportacaoArquivoAEJ/exportacaoarquivoaej.service';
import { AjustesPontoService } from './AjustesPonto/ajustesponto.service';
import { MotivoRecusaModalService } from './AjustesPonto/modal/motivo-recusa.modal.service';

import { FolhasPontoIndexController } from './FolhasDePonto/index/folhasdeponto.index.controller';
import { FolhasPontoVisualizarpdfModalController } from './FolhasDePonto/modals/visualizarpdf/visualizarpdf.modal.controller';
import { FolhasPontoFalhaGeracaoModalController } from './FolhasDePonto/modals/falhageracao/falhageracao.modal.controller';
import { FolhasPontoCancelarAssinaturaModalController } from './FolhasDePonto/modals/cancelarassinatura/cancelarassinatura.modal.controller';
import { AnalisesPontoIndexController } from './AnalisesPonto/index/analisesponto.index.controller';
import { PagamentosPontoIndexController } from './Pagamentos/index/pagamentos.index.controller';
import { PagamentosPontoConfirmModalController } from './Pagamentos/modals/pagamentos-confirm/pagamentos-confirm.modal.controller';
import { BancodeHorasIndexController } from './BancoDeHoras/index/bancodehoras.index.controller';
import { ExportacaoArquivoAejIndexController } from './ExportacaoArquivoAEJ/index/exportacaoarquivoaej.index.controller';
import { EstabelecimentosHabilitadosIndexController } from './EstabelecimentosHabilitados/index/estabelecimentoshabilitados.index.controller';
import { EstabelecimentosHabilitadosNewController } from './EstabelecimentosHabilitados/new/estabelecimentoshabilitados.new.controller';
import { EstabelecimentosHabilitadosEditController } from './EstabelecimentosHabilitados/edit/estabelecimentoshabilitados.edit.controller';
import { AjustesPontoIndexController } from './AjustesPonto/index/ajustesponto.controller';
import { MotivoRecusaModalController } from './AjustesPonto/modal/motivo-recusa.modal.controller';

import { EstabelecimentosHabilitadosService } from './EstabelecimentosHabilitados/estabelecimentoshabilitados.service';
import { EstabelecimentosHabilitadosModalService } from './EstabelecimentosHabilitados/modalBuscaColaboradores/estabelecimentoshabilitados.modalbuscarcolaboradores.service';
import { EstabelecimentosHabilitadosModalEditarResponsavelService } from './EstabelecimentosHabilitados/edit/modalEditarResponsavel/estabelecimentoshabilitados.modaleditarresponsavel.service';

import { RescisaoPontoController } from './Rescisao/rescisao.ponto.controller';
import { RescisaoPontoService } from './Rescisao/rescisao.ponto.service';
import { RescisaoPontoComponent } from './Rescisao/rescisao.ponto.component';

export const PontoModule = angular.module('PontoModule', [
        'ui.router.state',
        GeracaoDeMarcacoesPadraoModule,
        ApuracoesPontoModule
    ])
    .controller('FolhasPontoIndexController', FolhasPontoIndexController)
    .controller('FolhasPontoVisualizarpdfModalController', FolhasPontoVisualizarpdfModalController)
    .controller('FolhasPontoFalhaGeracaoModalController', FolhasPontoFalhaGeracaoModalController)
    .controller('FolhasPontoCancelarAssinaturaModalController', FolhasPontoCancelarAssinaturaModalController)
    .controller('AnalisesPontoIndexController', AnalisesPontoIndexController)
    .controller('PagamentosPontoIndexController', PagamentosPontoIndexController)
    .controller('PagamentosPontoConfirmModalController', PagamentosPontoConfirmModalController)
    .controller('BancodeHorasIndexController', BancodeHorasIndexController)
    .controller('ExportacaoArquivoAejIndexController', ExportacaoArquivoAejIndexController)
    .controller('EstabelecimentosHabilitadosIndexController', EstabelecimentosHabilitadosIndexController)
    .controller('EstabelecimentosHabilitadosNewController', EstabelecimentosHabilitadosNewController)
    .controller('EstabelecimentosHabilitadosEditController', EstabelecimentosHabilitadosEditController)
    .controller('RescisaoPontoController', RescisaoPontoController)
    .controller('AjustesPontoIndexController', AjustesPontoIndexController)
    .controller('MotivoRecusaModalController', MotivoRecusaModalController)
    .service('FolhasdePontoService', FolhasdePontoService)
    .service('FolhasPontoVisualizarpdfModalService', FolhasPontoVisualizarpdfModalService)
    .service('FolhasPontoFalhaGeracaoModalService', FolhasPontoFalhaGeracaoModalService)
    .service('FolhasPontoCancelarAssinaturaModalService', FolhasPontoCancelarAssinaturaModalService)
    .service('AnalisesPontoService', AnalisesPontoService)
    .service('PagamentosPontoService', PagamentosPontoService)
    .service('PagamentosPontoConfirmModalService', PagamentosPontoConfirmModalService)
    .service('GruposPontoService', GruposPontoService)
    .service('TrabalhadoresPontoService', TrabalhadoresPontoService)
    .service('TrabalhadoresApuracaoPontoService', TrabalhadoresApuracaoPontoService)
    .service('BancodeHorasService', BancodeHorasService)
    .service('ExportacaoArquivoAejService', ExportacaoArquivoAejService)
    .service('EstabelecimentosHabilitadosService', EstabelecimentosHabilitadosService)
    .service('EstabelecimentosHabilitadosModalService', EstabelecimentosHabilitadosModalService)
    .service('EstabelecimentosHabilitadosModalEditarResponsavelService', EstabelecimentosHabilitadosModalEditarResponsavelService)
    .service('RescisaoPontoService', RescisaoPontoService)
    .service('AjustesPontoService', AjustesPontoService)
    .service('MotivoRecusaModalService', MotivoRecusaModalService)
    .component('rescisaoPontoComponent', RescisaoPontoComponent)
    .config(FolhasdePontoListRouting)
    .config(AnalisesPontoListRouting)
    .config(PagamentosPontoListRouting)
    .config(BancodeHorasListRouting)
    .config(ExportacaoArquivoAejListRouting)
    .config(EstabelecimentosHabilitadosRouting)
    .config(AjustesPontoListRouting)
    .name;
